
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.46 8.46a.65.65 0 10-.92-.92l-2.89 2.89V2a.65.65 0 10-1.3 0v8.43L3.46 7.54a.65.65 0 10-.92.92l4 4a.648.648 0 00.45.19h.02a.65.65 0 00.445-.186","fill":"#fff"}}),_c('path',{attrs:{"d":"M11.46 8.46l-4 3.999 4-4z","fill":"#BEC6D1"}})])
          )
        }
      }
    